import { Heading, ModalHeader } from "@chakra-ui/react";

import { ModalBackButton } from "../BackButton";
import { ModalCloseButton } from "../CloseButton";

export const FormPageHeader = ({
  title = "Send",
  subTitle: _subTitle,
}: {
  title?: string;
  subTitle?: string;
}) => (
  <ModalHeader>
    <ModalBackButton />
    <Heading size="xl">{title}</Heading>
    <ModalCloseButton />
  </ModalHeader>
);
